module.exports = __webpack_public_path__ + "img/EG.63cda25a.svg";